<template>
  <div class="container">
    <van-nav-bar left-arrow @click-left="$router.back()" title="我的动态"></van-nav-bar>
    <van-tabs v-model="active">
      <van-tab title="作品">
        <InfiniteList :requestFn="getMyArticles">
          <template #default="{row:item}">
            <ArticleItem :item="item" />
          </template>
        </InfiniteList>
      </van-tab>
      <van-tab title="公告">
        <InfiniteList :requestFn="getAnnouncements">
          <template #default="{row}">
            <div class="an-item">
              <p>{{row.title}}</p>
              <p>{{row.pubdate}}</p>
            </div>
          </template>
        </InfiniteList>
      </van-tab>
      <van-tab title="数据">
        <div class="list van-hairline--top">
          <van-row gutter="10">
            <van-col span="12">
              <div class="card">
                <p><span>粉丝数</span><van-icon name="arrow"></van-icon></p>
                <p><span>{{figure.fans_count}}</span><span>人</span></p>
              </div>
            </van-col>
            <van-col span="12">
              <div class="card">
                <p><span>阅读数</span></p>
                <p><span>{{figure.read_count}}</span><span>次</span></p>
              </div>
            </van-col>
          </van-row>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import InfiniteList from './components/infinite-list'
import ArticleItem from '@/views/home/components/article-item'
import { getAnnouncements, getMyFigure } from '@/api/user'
import { getUserArticles } from '@/api/article'
export default {
  name: 'UserDynamic',
  components: {
    InfiniteList,
    ArticleItem
  },
  data () {
    return {
      active: null,
      figure: {}
    }
  },
  created () {
    getMyFigure().then(data => {
      this.figure = data
    })
  },
  methods: {
    getMyArticles (page, pageSize) {
      return getUserArticles(1, page, pageSize)
    },
    getAnnouncements
  }
}
</script>
<style scoped lang="less">
::v-deep .van-tab {
  flex: none;
  margin: 0 10px;
}
::v-deep .van-tabs__line {
  width: 28px;
}
::v-deep .van-cell {
  padding: 10px;
}
.an-item {
  line-height: 20px;
  padding: 10px;
  p {
    &:last-child {
      color: #999;
      font-size: 12px;
    }
  }
}
.list {
  padding: 10px;
  height: 100%;
  .card {
    background:#f9f9f9;
    border-radius: 8px;
    height: 75px;
    padding: 10px;
    p {
      padding-bottom: 10px;
      &:first-child {
        display: flex;
        align-items: center;
        justify-content: space-between;
        i {
          color: #999;
        }
      }
      &:last-child {
        span {
          &:first-child {
            font-size: 24px;
            margin-right: 10px;
          }
          &:last-child {
            color: #999;
          }
        }
      }
    }
  }
}
</style>
